<template>
  <page
    :title="promo ? 'Coupons in the ' + promo.name.toUpperCase() + ' promo': ''"
    :backTo="'/analytics/promo/'+this.$route.params.id"
    :loading="promo === null"
    size="is-desktop"
  >
    <div slot="page-header-right">
      <a class="button mr-2" :href="generateData(this.$route.params.id)" target="_blank">Export Coupons</a>
    </div>

    <div class="box" v-if="promo">
      <div class="level">
        <div class="level-left">
          <div class="media" style="align-items: center;">
            <div>
              <div class="subtitle"> Coupons Count: {{ promo.coupons_count }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="promo">
      <b-table
          :data="coupons.data"
          :loading="coupons.loading"
          paginated
          backend-pagination
          :current-page="coupons.current_page"
          :per-page="coupons.per_page"
          :total="coupons.total"
          @page-change="page => coupons.changePage(page)"
      >
          <template slot-scope="props">
              <b-table-column label="Coupon code" min-width="100">{{ props.row.code }}</b-table-column>
              <b-table-column label="Note" min-width="100">{{props.row.note}}</b-table-column>
              <b-table-column label="Created" width="120">
                  <div style="clear: both; display: block; " class="has-text-centered">{{ props.row.created_at }}</div>
              </b-table-column>
              <b-table-column label="Action" width="80" custom-key="actions">
                  <div >
                  <button class="button" @click="create(props.row)" style="margin-right:5px;">
                      Edit
                  </button>
                  </div>
              </b-table-column>
          </template>

          <template slot="empty">
              <section class="section">
                  <div class="content has-text-grey has-text-centered">
                  <p>
                      <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                  </p>
                  <p>No result.</p>
                  </div>
              </section>
          </template>
      </b-table>
    </div>
  </page>
</template>

<script>

import GenerateNewCoupons from "@/modules/admin/pages/promo/components/GenerateNewCoupons";

export default {
  data() {
    return {
      promo: null,
      coupons: []
    };
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    }
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/promo/group/" + this.$route.params.id)
        .then(response => {
          this.promo = response.data.data;
        })
        .catch(() => {
          alert("Couldn't fetch promo info from the server.");
        });
        
      this.loadCoupons();
    },

    loadCoupons() {
      this.coupons = new window.PaginatedRemoteCollection("/admin/api/analytics/promo/" + this.$route.params.id+"/coupons").load();
    },

    create(editCoupon) {
      this.$buefy.modal.open({
        component: GenerateNewCoupons,
        props: {
          group_id: this.$route.params.id,
          coupon: editCoupon,
          added: () => this.loadCoupons(),
        },
      });
    },

    // deleteIt(aCoupon) {
    //   this.$buefy.dialog.confirm({
    //     title: "Are you sure?",
    //     message: "Delete the coupon(code is "+aCoupon.code+") from the "+
    //     this.promo.name.toUpperCase()+" promo.",
    //     cancelText: "Cancel",
    //     confirmText: "Delete",
    //     type: "is-danger",
    //     hasIcon: true,
    //     onConfirm: () => {
    //       new window.Form()
    //         .delete(`/admin/api/-----/----/${aCoupon.id}`)
    //         .then(this.revoked);
    //     },
    //   });
    // },

    generateData(id) {
      return (
        `/admin/api/analytics/promo/${id}/export`
      );
    },
  }
};
</script>
